import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    DEPOSITSUMMARY_FAILURE,
    DEPOSITSUMMARY_LOAD,
    DEPOSITSUMMARY_SUCCESS
} from './depositSummaryActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let  newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                summary: []
            };

            return isEqual(state, newState) ? state : newState;

        case DEPOSITSUMMARY_LOAD:
            newState = {
                ...state,
                error: null,
                loading: true,
                summary: []
            };

            return isEqual(state, newState) ? state : newState;

        case DEPOSITSUMMARY_SUCCESS:
            newState = {
                ...state,
                count: action.count,
                loading: false,
                pages: action.pages,
                summary: action.depositSummary,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case DEPOSITSUMMARY_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getDepositSummaryEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'depositSummary')
);

export const getPages = createSelector(
    getDepositSummaryEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getDepositSummaryEntity,
    (entity) => get(entity, 'count')
);

export const getIsDepositSummaryLoading = createSelector(
    getDepositSummaryEntity,
    (entity) => get(entity, 'loading')
);

export const getDepositSummary = createSelector(
    getDepositSummaryEntity,
    (entity) => get(entity, 'summary')
);

export const getDepositSummaryError = createSelector(
    getDepositSummaryEntity,
    (entity) => get(entity, 'error')
);

export const getDepositSummaryErrorMessage = createSelector(
    getDepositSummaryError,
    (error) => get(error, 'message')
);

export const getHasMore = createSelector(
    getDepositSummaryEntity,
    (entity) => get(entity, 'hasMore')
);
